import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { I18nProvider } from "./lib/i18n";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Processing from "./pages/Processing";
import Result from "./pages/Result";
import Viewer from "./pages/Viewer";
import History from "./pages/History";
import Settings from "./pages/Settings";
import Blocked from "./pages/Blocked";
import AdminUsers from "./pages/AdminUsers";

function ProtectedRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        Carregando…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (user.blocked) return <Navigate to="/blocked" replace />;
  return children;
}

function AdminRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        Carregando…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (user.blocked) return <Navigate to="/blocked" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
}

function BlockedRoute() {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        Carregando…
      </div>
    );
  if (user === false) return <Navigate to="/login" replace />;
  if (!user.blocked) return <Navigate to="/" replace />;
  return <Blocked />;
}

function PublicRoute({ children }) {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center text-slate-400">
        Carregando…
      </div>
    );
  if (user) return <Navigate to="/" replace />;
  return children;
}

function App() {
  return (
    <I18nProvider>
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route
              path="/login"
              element={
                <PublicRoute>
                  <Login />
                </PublicRoute>
              }
            />
            <Route
              path="/processing"
              element={
                <ProtectedRoute>
                  <Processing />
                </ProtectedRoute>
              }
            />
            <Route
              path="/blocked"
              element={<BlockedRoute />}
            />
            <Route
              path="/viewer/:id"
              element={
                <ProtectedRoute>
                  <Viewer />
                </ProtectedRoute>
              }
            />
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/analyses" element={<History />} />
              <Route path="/result/:id" element={<Result />} />
              <Route path="/settings" element={<Settings />} />
              <Route
                path="/admin/users"
                element={
                  <AdminRoute>
                    <AdminUsers />
                  </AdminRoute>
                }
              />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </I18nProvider>
  );
}

export default App;
